import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApproachProfileService } from 'src/app/core/services/approach-profile.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-copy-approach-profiles',
  templateUrl: './copy-approach-profiles.component.html',
  styleUrls: ['./copy-approach-profiles.component.scss']
})
export class CopyApproachProfilesComponent {

  userForm: FormGroup = new FormGroup({});
  formFields = [
    { name: 'fromYear', label: 'From Year', type: 'select', space: 1, validators: [Validators.required], options: this.profileService.renewalYearOptions()},
    { name: 'toYear', label: 'To Year', type: 'select', space: 1, validators: [Validators.required], options: this.profileService.renewalYearOptions()},
  ];
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<CopyApproachProfilesComponent>,
    public profileService: ApproachProfileService,
    private utilService: UtilService
  ) { }

  async submit() {
    if (!this.userForm.valid) return; 
    this.submitting = true; 
    const payload = {...this.userForm.value,action:'copy'};
    this.profileService.copyProfiles(payload).subscribe({
      next: () => {
        this.utilService.openToastr('success', 'Copied all profiles from '+this.userForm.value.fromYear+' to '+this.userForm.value.toYear);
        this.dialogRef.close(true);
      },
      error: () => {
        this.utilService.openToastr('error', 'Failed to copy profiles');
        this.submitting = false;
      }
    });
  }

}
